import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '@infrastructure/objectUtils';

import { confirmRemoveFromList } from '@infrastructure/TableEdit/TableEditBase';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { SecurityService } from '@infrastructure/Security/SecurityService';


//import DateHelpers from '@infrastructure/DateHelpers';
import { StepDetailsService } from '@infrastructure/StepDetailsService/StepDetailsService';
import { DocumentosObservableService } from '@infrastructure/Documents/DocumentosObservable';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import { PersonType, PersonTypeString } from '@infrastructure/Models/const.personType';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { BeneficiaryItem } from '@infrastructure/Models/beneficiary-item';
import { LegalRepresentationState } from '../../../_infrastructure/Beneficiaries/legal-representation-state.service';
import { TranslateService } from '@ngx-translate/core';
import { StateCode, StatePhase } from '@infrastructure/Models/const.stateCodePhase';

interface ResultDocumentVM {
  mandatoryFileAlreadyExists: boolean;
  indexOfMandatoryFileEntry: number;
}

@Component({
  selector: 'documentation-pm-pre-stage',
  templateUrl: './documentation-pm-pre-stage.component.html',
  standalone: false
})
export class DocumentationPMPreStageComponent implements OnInit, OnDestroy, OnChanges {


  @Input() model: models.DocumentationPM = {} as models.DocumentationPM;
  @Input() dropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};
  @Input() instanceRole: string;
  @Input() beneficiaryList: models.BeneficiaryListVM[] = <models.BeneficiaryListVM[]>{};
  @Input() senderIdentification: models.SenderIdentificationVM = <models.SenderIdentificationVM>{};
  @Input() deceasedIdentification: models.DeceasedIdentificationVM = <models.DeceasedIdentificationVM>{};

  @Input() stateCode: string;
  @Input() statePhase: string;
  //@Input() subscriberNumber: string;
  @Input() workflowInstanceId: string;

  private onCardDataChanged() {


  }

  public LegalRepresentationState = LegalRepresentationState;
  public cardConfiguration: models.CardVM;

  public expandedRowIndex: number = null;
  public expandNewEntry: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes : models.DimensionVM[];


  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowIncapacity: boolean = false;
  public isMandatoryDocumentation: boolean;

  public documentsValue = DropdownsValues.dropListDocuments;


  public showAddDocButton: boolean = false;

  public version2: boolean;

  public professionalClass: string;

  public PGPAS: boolean;
  public isAtendimento: boolean;

  public initialMandatory: models.DocumentPM_VM[]=[];

  

  private firstTimeUpdating: boolean = false;
  public beneficiariesItemList: BeneficiaryItem[] = [];

  public isStateDevolvidoAoRemetente: boolean;

  public StateCode = StateCode;
  public StatePhase = StatePhase;


  constructor(
    private modalService: ModalService,
    private activeRoute: ActivatedRoute,
    private beneficiariesValuesService: BeneficiaryValuesService,
    private translateService: TranslateService

  ) {
    this.activeRoute.parent.paramMap.subscribe((params: ParamMap) => {
      this.workflowInstanceId = params.get('workflowInstanceId');
    });
   
  }

 
  ngOnInit(): void {
    this.showAddDocButton = true;
    if (this.stateCode == StateCode.Ativo && this.statePhase == StatePhase.DevolvidoAoRemetente) {
      this.isStateDevolvidoAoRemetente = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.model && !!this.beneficiaryList && !!this.senderIdentification && !!this.deceasedIdentification) {
      // Constroi array de referencia de beneficiario para depois atribuir ao owner nome dos documentos
      this.beneficiariesItemList = this.beneficiariesValuesService
        .buildBeneficiariesItemList(this.beneficiaryList, this.deceasedIdentification, this.senderIdentification, this.model.documentsList);

      // Construir lista de documentos obrigatórios
      this.verifyMandatoryDocumentation();

      // Verifica as propriedades em falta
      this.model.documentsList.forEach(doc => {
        if (doc.ownerName == null || doc.ownerName == undefined) {
          if (doc.beneficiaryID == PersonType.Sender || doc.beneficiaryID == PersonType.Deceased) {
            const beneficiary = this.beneficiariesItemList.find(el => el.value == doc.beneficiaryID);
            doc.ownerName = beneficiary?.description;

          } else {
            const beneficiary = this.beneficiaryList.find(el => el.beneficiaryID == doc.beneficiaryID);
            doc.ownerName = beneficiary?.beneficiaryName;

          }
        }
        if ((<any>doc).description == null || (<any>doc).description == undefined) {
          (<any>doc).description = doc.designationTypeDescription;
        }
      })
    }
   
    
  }

  private verifyMandatoryDocumentation() {
    //Certidão nascimento RL (associado ao RL)
    const existeDoc = this.model.documentsList?.filter(el => el.designationTypeCode == this.documentsValue.CertidaoNascReprLegal).length > 0;
    if (!existeDoc) {
      const description = this.dropdowns.options
        .find(el => el.dropdown === "dropListDocuments" &&
          el.value == this.documentsValue.CertidaoNascReprLegal &&
          el.filter == "PRSTG")?.description;

      const beneficiary = this.beneficiariesItemList.find(el => el.value == PersonType.Sender);

      let docToInsert: Partial< models.DocumentPM_VM> = {
        isMandatoryFile: true,
        beneficiaryID: PersonType.Sender,
        designationTypeCode: this.documentsValue.CertidaoNascReprLegal,
        designationTypeDescription: description,
        description: description,
        ownerName: beneficiary.description,
        fileOwnerTypeCode: PersonTypeString.Sender,
        nif: this.senderIdentification.NIF
      } as Partial<models.DocumentPM_VM>;

      this.model.documentsList.push(<any>docToInsert);
    }
    // Adicionar documentos por benificiario
    this.beneficiaryList.forEach(ben => {
      //  Comprovativo de representação legal
      let existeDoc = this.model.documentsList?.filter(el =>
        el.designationTypeCode == this.documentsValue.ComprovativoRepresLegal &&
        el.beneficiaryID == ben.beneficiaryID).length > 0;
      const isSender = ben.NIF == this.senderIdentification.NIF;
      if (!existeDoc && !isSender) {
        const description = this.dropdowns.options
          .find(el => el.dropdown === "dropListDocuments" &&
            el.value == this.documentsValue.ComprovativoRepresLegal &&
            el.filter == "PRSTG")?.description;

        let docToInsert: Partial<models.DocumentPM_VM> = {
          isMandatoryFile: true,
          beneficiaryID: ben.beneficiaryID,
          designationTypeCode: this.documentsValue.ComprovativoRepresLegal,
          designationTypeDescription: description,
          description: description,
          ownerName: ben.beneficiaryName,
          fileOwnerTypeCode: PersonTypeString.Beneficiary,
          nif: ben.NIF
        } as Partial<models.DocumentPM_VM>;

        this.model.documentsList.push(<any>docToInsert);
      }
      //Certidão de Nascimento do Habilitando
      existeDoc = this.model.documentsList?.filter(el =>
        el.designationTypeCode == this.documentsValue.CertidaoNascRequerente &&
        el.beneficiaryID == ben.beneficiaryID).length > 0;
      if (!existeDoc &&  !isSender) {
        const description = this.dropdowns.options
          .find(el => el.dropdown === "dropListDocuments" &&
            el.value == this.documentsValue.CertidaoNascRequerente &&
            el.filter == "PRSTG")?.description;

        let docToInsert: Partial<models.DocumentPM_VM> = {
          isMandatoryFile: true,
          beneficiaryID: ben.beneficiaryID,
          designationTypeCode: this.documentsValue.CertidaoNascRequerente,
          designationTypeDescription: description,
          description: description,
          ownerName: ben.beneficiaryName,
          fileOwnerTypeCode: PersonTypeString.Beneficiary,
          nif: ben.NIF
        } as Partial<models.DocumentPM_VM>;

        this.model.documentsList.push(<any>docToInsert);
      }

    });

    this.model.documentsList?.forEach(doc => {
      const description = (<any>doc).description;
      if (description == null || description == undefined) {
        (<any>doc).description=doc.designationTypeDescription
      }

      const ownerName = (<any>doc).ownerName;
      if (ownerName == null || ownerName == undefined) {
        (<any>doc).ownerName = this.beneficiaryList.find(el => el.beneficiaryID == doc.beneficiaryID)?.beneficiaryName;
      }
    })
  }





  public showDocRow(docItem: models.DocumentPM_VM) {
    let isMandatoryFile = (docItem.isMandatoryFile?.toString()?.toLowerCase() === 'true');
    if (isMandatoryFile) {
      return this.initialMandatory.find((v, i, a) => v === docItem) != undefined;
    }
    return true;
  }

  isWorkflowOnSubscriberAtendimento() {
    if (this.isAtendimento && !this.PGPAS)
      return true;
    else
      if (this.isAtendimento && this.PGPAS)
        return false;

    return false;
  }




  ngOnDestroy(): void {
  }

  public markAsMandatory(docItem: models.DocumentPM_VM): boolean {
    return docItem.isMandatoryFile?.toString()?.toLowerCase() == 'true';
  }

  public isNotRLDeferidaAndHasDocument(tableItem: models.DocumentPM_VM): boolean {
    let result = true;
    const stateRL = this.getBeneficiaryRLFromDocument(tableItem);
    if (stateRL == LegalRepresentationState.RepresentacaoDeferida) {
      if (!isNullOrUndefined(tableItem.fileID) && tableItem.fileID > 0) {
        result = true;
      } else {
        result = false;
      }
   
    }
    return result;
  }

  getIconBasedOnDocRL(tableItem: models.DocumentPM_VM): string {
    let result = 'text-primary icon-more';
    if (!isNullOrUndefined( tableItem.fileID)) {
      result = 'text-primary icon-edit';
    }
    //const stateRL = this.getBeneficiaryRLFromDocument(tableItem);
    //if (stateRL == LegalRepresentationState.RepresentacaoDeferida) {
    //  result = 'text-deferida icon-user'
    //}
    return result;
  }

  getTooltipBasedOnDocRL(tableItem: models.DocumentPM_VM): string{
    let result = "";
    const message = 'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.RLDiferida';
    const stateRL = this.getBeneficiaryRLFromDocument(tableItem);
    if (stateRL == LegalRepresentationState.RepresentacaoDeferida) {
      result = this.translateService.instant(message);
    }
    return result;
  }
  getBeneficiaryRLFromDocument(tableItem: models.DocumentPM_VM): LegalRepresentationState {
    const beneficiaryItem = this.beneficiariesItemList.find(el => el.value == tableItem.beneficiaryID);
    if (!isNullOrUndefined(beneficiaryItem)) {
      if (beneficiaryItem.type == PersonTypeString.Sender) {
        return LegalRepresentationState.RepresentaçaoIndeferida;
      } else {
        const beneficiary = this.beneficiaryList.find(el => el.beneficiaryID == beneficiaryItem.value);
        if (!isNullOrUndefined(beneficiary)) {
          return beneficiary.stateRL;
        } else {
          console.error("beneficiary not found");
        }
      }

    } else {
      console.error("beneficiaryItem not found");
    }
  }

  findInitialMandatory(docsList: models.DocumentPM_VM[]): models.DocumentPM_VM[] {
      let result = [];

      for (let i = 0; i < docsList.length; i++) {
        if (docsList[i].isMandatoryFile?.toString()?.toLowerCase() === 'true') {
          result.push(docsList[i])
        }
      }

      return result;
    
  }

  onDocumentationChanged(newDocumentList: models.DocumentPM_VM[]) {

    // Refresh intitial mandatory list
    this.initialMandatory = this.findInitialMandatory(newDocumentList) ?? [];

    this.model.documentsList = newDocumentList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;

  }
  
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }

  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }


}
